import {
  AddressFormType,
  AddressType,
  AddressTypeEnum,
  COUNTRY,
  Country,
  Language,
} from "../types";
import states from "../containers/AddressContainer/states.json";
import { decode } from "punycode";
import i18n from "../app/i18n";
import { t } from "i18next";

export const userAddressToUserAddressFormType = (
  address: AddressType
): AddressFormType => {
  return {
    id: address.id ?? "",
    address: address.address.line1,
    appartment: address.address.line2,
    city: address.address.city,
    country: address.address.country,
    state: address.address.state,
    zipcode: address.address.zipcode,
    phone: address.phone,
    email: address.email,
    firstName: address.firstName,
    lastName: address.lastName,
    organization: address.organization,
    type: address.type,
    communicationLanguage: address.communicationLanguage,
    ein: address.ein,
  };
};

//might not be needed
export const userAddressFormTypeToUserAddress = (
  address: AddressFormType
): AddressType => {
  return {
    id: address.id ?? "",
    address: {
      line1: address.address,
      line2: address.appartment,
      city: address.city,
      country: address.country,
      state: address.state,
      zipcode: address.zipcode,
    },
    phone: address.phone,
    email: address.email,
    firstName: address.firstName,
    lastName: address.lastName,
    organization: address.organization,
    type: address.type,
    communicationLanguage: address.communicationLanguage,
    ein: address.ein,
  };
};

export const getEmptyAddress = (userCountry: Country): AddressFormType => {
  const defaultCountry = userCountry || COUNTRY.CA;
  const defaultState = defaultCountry === COUNTRY.CA ? "QC" : states[0];
  const defaultLanguage = i18n.language as Language;
  return {
    id: undefined,
    address: "",
    appartment: "",
    city: "",
    country: defaultCountry,
    state: defaultState,
    zipcode: "",
    phone: "",
    email: "",
    firstName: "",
    lastName: "",
    organization: "",
    type: AddressTypeEnum.SHIPPING,
    communicationLanguage: defaultLanguage,
  };
};

// Function to convert storage format to display format
export function formatEmailForDisplay(email: string): string {
  if (!email) return "";

  const [localPart, domain] = email.split("@");
  if (!domain) return email;

  // Process each part of the domain separately
  const domainParts = domain.split(".");
  const decodedParts = domainParts.map((part) =>
    part.startsWith("xn--") ? decode(part.substring(4)) : part
  );

  return `${localPart}@${decodedParts.join(".")}`;
}

export const formatAddressForTools = (valueState: AddressType): string => {
  const {
    firstName,
    lastName,
    organization,
    communicationLanguage,
    address,
    phone,
    email,
  } = valueState;
  const name = `${firstName} ${lastName}`;
  const language = communicationLanguage ? `${communicationLanguage}` : "";
  const text = `${name};${organization};${language};${address.line1}\n${address.line2 || ""};${address.city};${address.state};${address.zipcode};${address.country};${phone};${email}`;
  return text;
};

export const formatAddressFormTypeToString = (
  address: AddressFormType,
  fullCountryName: boolean = false
) => {
  const addressArray = [
    address.organization,
    `${address.firstName} ${address.lastName}`,
    address.address,
    address.appartment,
    address.zipcode,
    address.city,
    address.state,
    fullCountryName ? t(`general.country.${address.country}`) : address.country,
  ];
  return addressArray.filter(Boolean).join(", ");
};

export const formatAddressToString = (
  address: AddressType,
  fullCountryName: boolean = false
) => {
  const addressArray = [
    address.organization,
    `${address.firstName} ${address.lastName}`,
    address.address.line1,
    address.address.line2,
    address.address.zipcode,
    address.address.city,
    address.address.state,
    fullCountryName
      ? t(`general.country.${address.address.country}`)
      : address.address.country,
  ];
  return addressArray.filter(Boolean).join(", ");
};
